import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0px",
    position: "fixed",
    borderRadius: "8px",
    border: "2px solid rgb(193, 195, 202)",
    zIndex: "22",
  },
  overlay: {
    zIndex: "21",
    backgroundColor: "rgba(0,0,0,0.2)",
  },
};

Modal.setAppElement("#book-app");

Modal.defaultStyles.overlay.backgroundColor = "rgb(191, 191, 191, 0.3)";
const ModalPopUp = ({
  isOpen,
  children,
  onRequestClose,
  style: { content = {}, overlay = {} } = {},
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        content: {
          ...customStyles.content,
          ...content,
        },
        overlay: {
          ...customStyles.overlay,
          ...overlay,
        },
      }}
      contentLabel="Example Modal"
    >
      {children}
    </Modal>
  );
};
export default ModalPopUp;
